import React, { Component } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { Redirect } from "react-router-dom";

import apis from "../../services/Admin";

import PerfilAgente from "../../components/Admin/PerfilAgente";
import DispositivosList from "../../components/Admin/DispositivosList";
import ModalCustom from "../../components/hoc/ModalCustom";
import ConsultaImei from "../../components/Home/ConsultaImei";
import Loading from "../../components/Loading";
import AdminSession from "../../libs/AdminSession";
import ModalLogout from "../../components/Admin/Modal/ModalLogout";

const message = "Informe o motivo para indeferir o registro";

export default class Dashboard extends Component {
  state = {
    dispositivos: [],
    dispositivo: {},
    modal: false,
    validSelect: false,
    obs: "",
    Logout: false,
    userInfo: {},
    showSearchImei: false,
    verifyToken: false,
    userPerfil: null,
    errToken: false,
    loadList: false,
    isLoading: true,

    modalUser: false,
    modalConfirm: false,
    modalLogout: false,
  };

  async componentWillMount() {
    await AdminSession.checkToken()
      .then(() => {
        this.setState({
          verifyToken: true,
          userPerfil: AdminSession.getUser(),
          isLoading: false,
        });
      })
      .catch((err) => {
        this.onLogout();
      });

    await this.loadDispositivos();
  }

  loadDispositivos = async () => {
    this.setState({ loadList: false });

    await apis
      .DispPendentes()
      .then((r) => {
        this.setState({ dispositivos: r.data, loadList: true });
      })
      .catch((e) => this.setState({ errToken: true, loadList: true }));
  };

  onChangeSituacao = (e, id) => {
    const valor = e.target.value;
    const index = this.state.dispositivos.findIndex((item) => item.id === id);

    const { dispositivos } = this.state;
    const updated = valor !== "0" ? true : false;
    dispositivos[index] = { ...dispositivos[index], situacao: valor, updated };

    this.setState({ dispositivos });
  };

  showModal = () => {
    this.setState({ modal: !this.state.modal });
  };

  showCompImei = () => {
    this.setState({ showSearchImei: !this.state.showSearchImei });
  };

  showModalConfirm = (dispositivo) => {
    this.setState({ modalConfirm: !this.state.modalConfirm, dispositivo });
  };

  confirmBO = (dispositivo) => {
    const disp = { ...dispositivo, confirmacao: 2 };
    // console.log("--->", disp);
    apis
      .confirmaBO(disp.id, disp)
      .then((r) => {
        this.loadDispositivos();
        this.showModalConfirm();
      })
      .catch((e) => this.setState({ errToken: true }));
  };

  indeferirBO = (dispositivo) => {
    const disp = { ...dispositivo, confirmacao: 3 };
    apis
      .confirmaBO(disp.id, disp)
      .then((r) => {
        this.loadDispositivos();
        this.showModal();
      })
      .catch((e) => this.setState({ errToken: true }));
  };

  setDispositivo = (id) => {
    const dispositivo = this.state.dispositivos.find((item) => item.id === id);
    this.setState({ modal: !this.state.modal, dispositivo });
    return (
      <div>
        <p>{dispositivo.imei}</p>
        <p>{dispositivo.numero_bo}</p>
        <p>{dispositivo.cpf}</p>
      </div>
    );
  };

  onLogout = () => {
    AdminSession.logout();
    this.setState({ Logout: true, isLoading: false });
  };

  userInfo = async (u) => {
    this.setState({ userInfo: u, modalUser: !this.state.modalUser });
  };

  showModal = (key, value) => {
    this.setState({
      [key]: value,
    });
  };

  render() {
    if (this.state.isLoading) return <Loading />;

    if (this.state.Logout) return <Redirect to="/admin" />;

    return (
      <div className="container Home" style={{ color: "black" }}>
        <PerfilAgente
          handleLogout={() => this.showModal("modalLogout", true)}
          showCompImei={this.showCompImei}
          userPerfil={this.state.userPerfil}
        />

        {this.state.showSearchImei ? (
          <ConsultaImei userInfo={this.userInfo} showCompImei={this.showCompImei} />
        ) : (
          <div>
            <DispositivosList
              list={this.state.dispositivos}
              dispositivo={this.state.dispositivo}
              loadDispositivos={this.loadDispositivos}
              onChangeSituacao={this.onChangeSituacao}
              showModal={this.showModal}
              showModalConfirm={this.showModalConfirm}
              setDispositivo={this.setDispositivo}
              confirmBO={this.confirmBO}
              changeObs={this.changeObs}
              userInfo={this.userInfo}
              reload={this.loadDispositivos}
              loadList={this.state.loadList}
            />
          </div>
        )}

        <ModalCustom
          show={this.state.modal}
          body={this.state.dispositivo}
          message={message}
          ok={() => this.indeferirBO(this.state.dispositivo)}
          cancel={(e) => this.setState({ modal: !this.state.modal })}
          indeferirBO={this.indeferirBO}
          changeObs={this.changeObs}
        />

        <ModalAttention
          isOpen={this.state.modalConfirm}
          ok={() => this.confirmBO(this.state.dispositivo)}
          cancel={() => this.showModalConfirm()}
        />

        <ModalUser
          isOpen={this.state.modalUser}
          body={this.state.userInfo}
          cancel={() => this.setState({ modalUser: !this.state.modalUser })}
        />

        <ModalLogout
          show={this.state.modalLogout}
          onConfirm={this.onLogout}
          onCancel={() => this.showModal("modalLogout", false)}
        />
      </div>
    );
  }
}

const ModalAttention = (props) => (
  <Modal isOpen={props.isOpen}>
    <ModalHeader>Atenção!</ModalHeader>
    <ModalBody>
      <p>Você confirma a validação deste registro ?</p>
    </ModalBody>
    <ModalFooter>
      <button className="btn btn-primary" onClick={props.ok}>
        Confirmar
      </button>
      <button className="btn btn-danger" onClick={props.cancel}>
        Cancelar
      </button>
    </ModalFooter>
  </Modal>
);

const ModalUser = (props) => (
  <Modal isOpen={props.isOpen}>
    <ModalHeader>
      <h3>Dados do usuário</h3>
    </ModalHeader>
    <ModalBody>
      <p>
        <strong>Nome:</strong> {props.body.nome}
      </p>
      <p>
        <strong>CPF:</strong> {props.body.cpf}
      </p>
      <p>
        <strong>Email:</strong> {props.body.email}
      </p>
      <p>
        <strong>Nome da mãe:</strong> {props.body.nome_mae}
      </p>
      <p>
        <strong>Telefone:</strong> {props.body.telefone}
      </p>
      <p>
        <strong>Data de nascimento:</strong> {props.body.datanasc}
      </p>
    </ModalBody>
    <ModalFooter>
      <button className="btn btn-primary" onClick={props.cancel}>
        Ok
      </button>
    </ModalFooter>
  </Modal>
);

// const ModalError = (props) => (
//   <Modal isOpen={props.isOpen}>
//     <ModalHeader>Atenção!</ModalHeader>
//     <ModalBody>
//       <p>
//         Não foi possivel acessar a autenticação do sistema, favor entrar em contato com o
//         administrador do sistema.
//       </p>
//     </ModalBody>
//     <ModalFooter>
//       <button className="btn btn-primary" onClick={props.ok}>
//         ok
//       </button>
//     </ModalFooter>
//   </Modal>
// );



// WEBPACK FOOTER //
// ./src/pages/Admin/Dashboard.js